import React from 'react';
import InfoPage from './InfoPage';

const PrivacyPage = () => {
  return <InfoPage type="privacy" />;
};

export default PrivacyPage;
